import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as ArrowUp } from 'assets/images/arrow-up.svg';

export const Button = styled.div`
  position: fixed;
  bottom: 5%;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0 2px 16px 0 rgb(0 0 0 / 30%);
  background: ${ColorPalette.HEX.White};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const IconArrow = styled(ArrowUp)`
  width: 26px;
  height: 26px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;
